import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Seiten
import Home from "./pages/Home";
import Projekte from "./pages/Projekte";
import Zertifikate from "./pages/Zertifikate";
import Profil from "./pages/Profil";
import Kenntnisse from "./pages/Kenntnisse";
import Kontakt from "./pages/Kontakt";


// Layout-Wrapper mit Navbar
import Layout from "./components/Layout";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Alle Seiten werden im Layout eingebettet */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/projekte" element={<Projekte />} />
          <Route path="/zertifikate" element={<Zertifikate />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/kenntnisse" element={<Kenntnisse />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Route>
      </Routes>
    </Router>
  );
}
